import {Product} from '~/gql/generated';

export function getDiscountCodeList(products: Product[], code?: string) {
  const codes = (products || []).map((product) => product.discount?.code);
  if (code) {
    codes.push(code);
  }
  return Array.from(new Set(codes.filter(Boolean))).join(',');
}
